import { Input } from "antd";
import Masked from "react-input-mask";
import { ReactNode } from "react";
import NumberFormat from "react-number-format";
import { InputLabel, MenuItem, Select } from "@mui/material";

interface InputParams {
  label?: ReactNode;
  disabled?: boolean;
  placeholder?: string;
  maxLength?: number;
  className?: string;
}

interface MaskInputParams extends InputParams {
  mask?: string;
}

interface NumberInputParams extends InputParams {
  prefix?: string;
  decimalScale?: number;
  allowNegative?: boolean;
}

interface SelectInputParams extends InputParams {
  defaultValue?: any;
  options?: { label: ReactNode; value: any }[];
  value?: any;
}

export const TextInput = ({ placeholder, disabled }: InputParams) => (
  <Input placeholder={placeholder} disabled={disabled} />
);

export const SelectLabled = ({
  options,
  label,
  disabled,
  value,
  defaultValue,
  ...rest
}: SelectInputParams & {
  onChange?: Function;
  value?: any;
  defaultValue?: any;
}) => {
  const handleChange = (e: any) => {
    rest.onChange?.(e.target.value);
  };

  return (
    <>
      <InputLabel style={{color: "black", marginBottom: "17px", marginTop: "11px"}} id={`id-label-${label?.toString()}`}>{label}</InputLabel>
      <Select
        variant="filled"
        disabled={disabled}
        onChange={handleChange}
        value={value ?? ""}
        displayEmpty
        defaultValue={defaultValue}
        className="select-mui"
      >
        {options?.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export const SelectInput = (props: SelectInputParams) => {
  return <SelectLabled {...props} />;
};

export const NumberInput = ({
  prefix = "",
  disabled = false,
  decimalScale = 2,
  placeholder = "",
  allowNegative = false,
}: NumberInputParams) => (
  <NumberFormat
    disabled={disabled}
    prefix={prefix}
    decimalSeparator=","
    thousandSeparator="."
    placeholder={placeholder}
    decimalScale={decimalScale}
    allowNegative={allowNegative}
    className="ant-input ant-input-lg"
  />
);

export const MaskInput = ({
  mask = "",
  placeholder = "",
  disabled = false,
}: MaskInputParams) => (
  <Masked
    mask={mask}
    disabled={disabled}
    placeholder={placeholder}
    className="ant-input ant-input-lg"
  />
);